/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplierResponseLineDto } from './SupplierResponseLineDto';
import {
    SupplierResponseLineDtoFromJSON,
    SupplierResponseLineDtoFromJSONTyped,
    SupplierResponseLineDtoToJSON,
} from './SupplierResponseLineDto';

/**
 * 
 * @export
 * @interface RecordSupplierResponseDto
 */
export interface RecordSupplierResponseDto {
    /**
     * 
     * @type {Array<SupplierResponseLineDto>}
     * @memberof RecordSupplierResponseDto
     */
    lines: Array<SupplierResponseLineDto>;
}

/**
 * Check if a given object implements the RecordSupplierResponseDto interface.
 */
export function instanceOfRecordSupplierResponseDto(value: object): value is RecordSupplierResponseDto {
    if (!('lines' in value) || value['lines'] === undefined) return false;
    return true;
}

export function RecordSupplierResponseDtoFromJSON(json: any): RecordSupplierResponseDto {
    return RecordSupplierResponseDtoFromJSONTyped(json, false);
}

export function RecordSupplierResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordSupplierResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lines': ((json['lines'] as Array<any>).map(SupplierResponseLineDtoFromJSON)),
    };
}

export function RecordSupplierResponseDtoToJSON(value?: RecordSupplierResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lines': ((value['lines'] as Array<any>).map(SupplierResponseLineDtoToJSON)),
    };
}

